import { Component, OnDestroy, OnInit } from '@angular/core';
import { ResultListDto } from '../../../../service/dto';
import { Subscription } from 'rxjs';
import { Filter, OnTableChange, TableColumn } from '../../../../components/table/table.component';
import { HttpInsuranceProductService } from '../../../../service/http-insurance-product.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-policy-payment-list',
  standalone: false,
  templateUrl: './policy-payment-list.component.html',
  styleUrl: './policy-payment-list.component.scss'
})
export class PolicyPaymentListComponent implements OnInit, OnDestroy {
	data?: ResultListDto<any>;
	subscription = new Subscription();
	tableState: OnTableChange = { pageIndex: 0, pageSize: 0, filters: [] };

	loading = false;
	filters: Filter[] = [
		// { label: 'ID Number', name: 'idNumber', type: 'Text', format: '^\\w+$' },
		// { label: 'Name', name: 'name', type: 'Text', format: '^\\w.*$' },
		// { label: 'Surname', name: 'surname', type: 'Text', format: '^\\w.*$' },
		// { label: 'Msisdn', name: 'msisdn', type: 'Text', format: '^\\w.*$' },
		// { label: 'Email Address', name: 'emailAddress', type: 'Text', format: '^\\w.*$' },
		// { label: 'Membership Number', name: 'membershipNumber', type: 'Text', format: '^\\w.*$' }
	];
	columnRef: TableColumn[] = [
		{ "title": "Name", "property": "member.name" },
		{ "title": "Surname", "property": "member.surname" },
		{ "title": "ID Number", "property": "member.idNumber" },
		{ "title": "Claim Created", "property": "claim.createdAt" },
		{ "title": "Final Approval", "property": "approval.createdAt" },
		{ "title": "Amount", "property": "amount" }
	];

	constructor(private router: Router) {

	}
	ngOnInit(): void {
		this.doFetchResults({ pageIndex: 1, pageSize: 30, filters: [] });
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	doFetchResults(input: OnTableChange) {
		if (JSON.stringify(this.tableState) == JSON.stringify(input)) {
			return;
		}
		this.tableState = input;
		// this.loading = true;
	}
}
